<template><section><h2>自定义</h2>
<block-demo tip="" source="const shape =
  &#39;m301.855,200.202c-3.674,-1.385 -7.452,-1.966 -11.146,-1.794c0.659,-2.922 0.844,-5.85 0.58,-8.719c-0.937,-10.407 -7.663,-19.864 -18.063,-23.834c-10.697,-4.043 -22.298,-1.168 -29.902,6.403c3.015,0.026 6.074,0.594 9.035,1.728c13.626,5.151 20.465,20.379 15.32,34.004c-1.905,5.02 -5.177,9.115 -9.22,12.05c-6.951,4.992 -16.19,6.536 -24.777,3.271c-13.625,-5.137 -20.471,-20.371 -15.32,-34.004c0.673,-1.768 1.523,-3.423 2.526,-4.992l-0.014,0c0,0 0,0 0,0.014c4.386,-6.853 8.145,-14.279 11.146,-22.187c23.294,-61.505 -7.689,-130.278 -69.215,-153.579c-61.532,-23.293 -130.279,7.69 -153.579,69.202c-6.371,16.785 -8.679,34.097 -7.426,50.901c0.026,0.554 0.079,1.121 0.132,1.688c4.973,57.107 41.767,109.148 98.945,130.793c58.162,22.008 121.303,6.529 162.839,-34.465c7.103,-6.893 17.826,-9.444 27.679,-5.719c11.858,4.491 18.565,16.6 16.719,28.643c4.438,-3.126 8.033,-7.564 10.117,-13.045c5.52,-14.569 -1.82,-30.852 -16.376,-36.359z&#39;

const { Chart, Wave } = qcharts

const chart = new Chart({ container: &#39;#app&#39; })

const wave = new Wave({
  //固定位置，窗口变化的时候，位置不移动
  clientRect: { top: 0, left: 0 },
  percent: 65,
  shape: shape,
  formatter: per =&gt; {
    return &#39;总占比：&#39; + per + &#39;%&#39;
  }
})
//文本样式
wave.style(&#39;text&#39;, {
  fillColor: &#39;#fff&#39;,
  pos: [130, 130]
})
chart.append(wave)
setTimeout(_ =&gt; {
  wave.attr({ percent: 80 })
}, 2000)
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> shape =
  <span class="hljs-string">'m301.855,200.202c-3.674,-1.385 -7.452,-1.966 -11.146,-1.794c0.659,-2.922 0.844,-5.85 0.58,-8.719c-0.937,-10.407 -7.663,-19.864 -18.063,-23.834c-10.697,-4.043 -22.298,-1.168 -29.902,6.403c3.015,0.026 6.074,0.594 9.035,1.728c13.626,5.151 20.465,20.379 15.32,34.004c-1.905,5.02 -5.177,9.115 -9.22,12.05c-6.951,4.992 -16.19,6.536 -24.777,3.271c-13.625,-5.137 -20.471,-20.371 -15.32,-34.004c0.673,-1.768 1.523,-3.423 2.526,-4.992l-0.014,0c0,0 0,0 0,0.014c4.386,-6.853 8.145,-14.279 11.146,-22.187c23.294,-61.505 -7.689,-130.278 -69.215,-153.579c-61.532,-23.293 -130.279,7.69 -153.579,69.202c-6.371,16.785 -8.679,34.097 -7.426,50.901c0.026,0.554 0.079,1.121 0.132,1.688c4.973,57.107 41.767,109.148 98.945,130.793c58.162,22.008 121.303,6.529 162.839,-34.465c7.103,-6.893 17.826,-9.444 27.679,-5.719c11.858,4.491 18.565,16.6 16.719,28.643c4.438,-3.126 8.033,-7.564 10.117,-13.045c5.52,-14.569 -1.82,-30.852 -16.376,-36.359z'</span>

<span class="hljs-keyword">const</span> { Chart, Wave } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({ <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span> })

<span class="hljs-keyword">const</span> wave = <span class="hljs-keyword">new</span> Wave({
  <span class="hljs-comment">//固定位置，窗口变化的时候，位置不移动</span>
  <span class="hljs-attr">clientRect</span>: { <span class="hljs-attr">top</span>: <span class="hljs-number">0</span>, <span class="hljs-attr">left</span>: <span class="hljs-number">0</span> },
  <span class="hljs-attr">percent</span>: <span class="hljs-number">65</span>,
  <span class="hljs-attr">shape</span>: shape,
  <span class="hljs-attr">formatter</span>: <span class="hljs-function"><span class="hljs-params">per</span> =&gt;</span> {
    <span class="hljs-keyword">return</span> <span class="hljs-string">'总占比：'</span> + per + <span class="hljs-string">'%'</span>
  }
})
<span class="hljs-comment">//文本样式</span>
wave.style(<span class="hljs-string">'text'</span>, {
  <span class="hljs-attr">fillColor</span>: <span class="hljs-string">'#fff'</span>,
  <span class="hljs-attr">pos</span>: [<span class="hljs-number">130</span>, <span class="hljs-number">130</span>]
})
chart.append(wave)
setTimeout(<span class="hljs-function"><span class="hljs-params">_</span> =&gt;</span> {
  wave.attr({ <span class="hljs-attr">percent</span>: <span class="hljs-number">80</span> })
}, <span class="hljs-number">2000</span>)
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>